import { useForm } from "react-hook-form";
import { Container, Grid } from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import { useTranslation } from "react-i18next";

//import utils
import { fixNumbers } from "../../utils/utility";

//import constants
import BASE_URL from "../../constants/baseUrls";

//import general components
import { BaseButton } from "../../components/common/base-button/base-button";
import BaseTextField from "../../components/common/base-text-field/base-text-field";
import BaseTitle from "../../components/common/base-title/base-title";
import Footer from "../../components/common/footer/footer";

//import styles
import "./submit-complaints.scss";

function SubmitComplaints() {
    //general variables
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");

    //initial form values
    const initialFormState = {
        creator: "",
        email: "",
        phoneNumber: "",
        message: "",
    };

    //initialize form with react-hook-form
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: initialFormState,
    });

    //register options
    const registerOptions = {
        creator: { required: ` ` },
        email: { required: ` ` },
        phoneNumber: {
            required: ` `,
            maxLength: { value: 11, message: `${t("phoneNumberValidation1")}` },
            minLength: { value: 11, message: `${t("phoneNumberValidation2")}` },
            pattern: { value: /^(09|\u06F0\u06F9)[0-9\u06F0-\u06F9]{9}$/, message: `${t("phoneNumberValidation3")}` },
        },
        message: { required: ` ` },
    };

    //handle form submission with registration data
    const handleRegistration = async data => {
        var contactFormData = new FormData();
        const formFields = {
            user_name: data.creator,
            user_email: fixNumbers(data?.email),
            user_phone: fixNumbers(data.phoneNumber),
            text: data.message,
        };
        Object.entries(formFields).forEach(([key, value]) => {
            contactFormData.append(key, value);
        });

        try {
            const response = await axios.post(`${BASE_URL}/support/site/contact_form/`, contactFormData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.status === 200) return toast.success(t("successMessage"), { toastId: "custom-id-yes" });
        } catch (error) {
            return toast.error(t("errorMessage8"), { toastId: "custom-id-yes" });
        }
    };

    //handle form submission errors
    const handleError = error => {
        console.log(error);
    };

    return (
        <>
            <Container maxWidth="xl">
                <Grid
                    className="submit-complaints"
                    container
                    item
                    xs={12}
                    rowGap={{ xs: 1, md: 3 }}
                    justifyContent="center"
                    alignItems="center"
                    mt={{ xs: 2, md: 0 }}
                    mb={{ xs: 8, md: 18 }}
                >
                    <BaseTitle title={t("submitComplaints")} dividerColor="1px solid var(--medium-gray-color)" />
                    <Grid
                        className="submit-complaints__form"
                        component="form"
                        container
                        item
                        md={5}
                        rowGap={3}
                        onSubmit={handleSubmit(handleRegistration, handleError)}
                    >
                        {[
                            { name: "creator", label: `${t("firstName")} ${t("lastName")} *` },
                            { name: "email", label: `${t("email")}*` },
                            { name: "phoneNumber", label: `${t("phoneNumber")} *` },
                            { name: "message", label: `${t("message")}*`, multiline: true, rows: 6 },
                        ].map(field => (
                            <Grid container item xs={12} key={field.name}>
                                <BaseTextField
                                    label={field.label}
                                    radius="10px"
                                    name={field.name}
                                    register={{ ...register(field.name, registerOptions[field.name]) }}
                                    error={errors?.[field.name]?.message}
                                    multiline={field?.multiline}
                                    rows={field?.rows}
                                />
                            </Grid>
                        ))}
                        <Grid container item xs={12} justifyContent="flex-end">
                            <BaseButton text={t("submitRequest")} color="primary" type="submit" size="large" radius="radius-10" />
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
            <Footer />
        </>
    );
}
export default SubmitComplaints;
